export const VIEW_COURSE = {
  LIBRARY_WELCOME_TEXT: "Welcome to Library Management",
  STATUS_LABEL: "Status",
  STATE: "State",
  EMAIL_SENT: "Email Sent",
  LAST_MODIFIED_BY_LABEL: "Last Modified By",
  TEMPLATE_LABEL: "VM Template Associated",
  VAPP_TEMPLATE_NAME: "vApp Template Name",
  DATE_TIME_LABEL: "Date & Time",
  ACTIONS_LABEL: "Actions",
  DEPLOY_COURSE_INSTANCES: "Deploy Course Instances",
  DUPLICATE: {
    DUPLICATE_COURSE_MESSAGE_LINE1: "You are duplicating a course template.",
    DUPLICATE_COURSE_MESSAGE_LINE2: "The duplicate will be saved as a draft",
    CANCEL: "Cancel",
    CONTINUE: "Continue",
  },
  DELETE: {
    DELETE_COURSE_MESSAGE_LINE1: "Are you sure you want to delete the template",
    DELETE_COURSE_MESSAGE_LINE2: "This action cannot be undone and may affect user relying on this template.",
    CANCEL: "CANCEL",
    DELETE_ANYWAY: "DELETE ANYWAY",
    DELETE_INSTANCE_MESSAGE_LINE1: "You are about to permanently delete",
    DELETE_INSTANCE_MESSAGE_LINE2: "which is currently active and associated with:",
    DELETE_INSTANCE_MESSAGE_LINE3: "This action cannot be undone. All progress and associations will be lost.",
    FORCE_DELETE: "FORCE DELETE"

  },
  MULTIPLE_DELETE: {
    MULTIPLE_DELETE_COURSE_MESSAGE_LINE1: "Are you sure you want to delete the following",
    MULTIPLE_DELETE_COURSE_MESSAGE_LINE2: "This action cannot be undone and may affect users relying on these templates.",
    TITLE:"Delete Course Templates",
    CANCEL: "Cancel",
    DELETE_TEMPLATES: "Delete Templates",
  }
};

export const VIEW_COURSE_LIST = {
  TITLE: "List of Templates",
  TITLES: {
    COURSE_ENVIRONMENTS: "List of Course Environments",
    TEMPLATES: "List of Templates", 
    DRAFTS: "List of Drafts",
    DEPLOYED_COURSES: "List of Deployed Courses"
  },
  TOTAL_LABEL: "total",
  CREATE_NEW_COURSE: "Create Environment",
  FILTER_SORT: "Filter & sort",
  DELETE_SELECTED: "Delete selected",
  SELECT_ALL: "Select all",
  DESELECT_ALL: "Deselect all",
  SEARCH_PLACEHOLDER: "Search within viewable",
  TOAST_MESSAGE: {
    SUCCESS_DELETE_MESSAGE: "Course template deleted successfully",
    ERROR_DELETE_MESSAGE: "Failed to delete course template"
  },
  INSTANCE_TOAST_MESSAGE: {
    SUCCESS_DELETE_MESSAGE: "Deployed instance has been successfully deleted.",
    ERROR_DELETE_MESSAGE: "Failed to delete Deployed course"
  }
};

export const ABOUT_US = {
  heading: "About Honeywell Digital Prime Twin",
  version: "Version R120.1",
  pat: "Pat.: hsmpats.com",
  copyright: "Copyright 2025, Honeywell International Inc., All rights reserved",
  end_user: "End User License Agreement"
}

export const TABLE_HEADING = {
  COURSE_NAME: "Course Name",
  DESCRIPTION: "Description",
  COURSE_DESCRIPTION: "Course Description",
  STATUS: "Status",
  VMS_LINKED: "VMS Linked",
  LAST_MODIFIED_DATE: "Last Modified Date",
  LAST_MODIFIED_BY: "Last Modified By"
}

export const courseCountData = [
  {
    "id": "0",
    "count": 8,
    "courseType": "totalCourse"
  },
  {
    "id": "1",
    "count": 8,
    "courseType": "published"
  },
  {
    "id": "2",
    "count": 3,
    "courseType": "draft"
  },
  {
    "id": "3",
    "count": 6,
    "courseType": "courseInstances"
  }
]

export const courseData = {
  CourseDefinitionData: [
    {
      CourseName: "AI Tools",
      CourseDescription: "Details on AI Tools",
      CourseID: "1",
      courseDefintionID: "1",
      courseInstanceID: 1,
      IsDraft: "1",
      LastModifiedDate: "2025-20-06",
      LastModifiedBy: "Amit Jha",
      Duration: "5",
      vAppTemplateID: "guid",
      vAppTemplateName: "AICapability1",
      vmDetails: {
        vm1: {
          vmId: "guid",
          vmName: "VM01",
          vmURL: "https://",
          OSType: "WINDOWS",
          OSVer: "11",
          RAMValue: "16",
          RAMUnit: "GB",
          CPU: "4 cores",
          Storage: "1 TB",
          IPv4: "129.255.1.111",
          IsPausable: "1",
        },
        vm2: {
          vmId: "guid",
          vmName: "VM02",
          vmURL: "https://",
          OSType: "WINDOWS",
          OSVer: "11",
          RAMValue: "16",
          RAMUnit: "GB",
          CPU: "4 cores",
          Storage: "512 GB",
          IPv4: "129.255.1.10",
          IsPausable: "1",
        },
      },
    },
    {
      CourseName: "Quality Control",
      CourseDescription: "Details on Quality Control",
      CourseID: "2",
      courseDefintionID: "2",
      courseInstanceID: 2,
      IsDraft: "0",
      LastModifiedDate: "2025-06-22",
      LastModifiedBy: "Prakash Tevde",
      Duration: "30",
      vAppTemplateID: "guid",
      vAppTemplateName: "Capability1",
      inProgress: true,
      vmDetails: {
        vm1: {
          vmId: "guid",
          vmName: "VM01",
          vmURL: "https://",
          OSType: "WINDOWS",
          OSVer: "11",
          RAMValue: "16",
          RAMUnit: "GB",
          CPU: "4 cores",
          Storage: "1 TB",
          IPv4: "129.255.1.11",
          IsPausable: "1",
        },
        vm2: {
          vmId: "guid",
          vmName: "VM02",
          vmURL: "https://",
          OSType: "WINDOWS",
          OSVer: "11",
          RAMValue: "16",
          RAMUnit: "GB",
          CPU: "4 cores",
          Storage: "512 GB",
          IPv4: "129.255.1.10",
          IsPausable: "0",
        },
      },
    },
    {
      CourseName: "Automation",
      CourseDescription: "Automation",
      CourseID: "3",
      courseDefintionID: "3",
      courseInstanceID: 3,
      IsDraft: "1",
      LastModifiedDate: "2025-06-10",
      LastModifiedBy: "Jhon Crook",
      Duration: "30",
      vAppTemplateID: "guid",
      vAppTemplateName: "Automation1",
      vmDetails: {
        vm1: {
          vmId: "guid",
          vmName: "VM01",
          vmURL: "https://",
          OSType: "WINDOWS",
          OSVer: "11",
          RAMValue: "16",
          RAMUnit: "GB",
          CPU: "4 cores",
          Storage: "512 GB",
          IPv4: "129.255.1.10",
          IsPausable: "1",
        },
      },
    },
  ],
};

export const mockCourses = [
  {
    id: "1",
    code: "VAPP_TEMP_COURSE001",
    name: "Vitrtual training course",
    status: "Published",
    statusColor: "green",
    lastModifiedBy: "John Doe",
    template: "VM_Template_03",
    dateTime: "5/15/2025 4:18 PM",
  },
  {
    id: "2",
    code: "VAPP_TEMP_COURSE002",
    name: "Data Science Bootcamp",
    status: "Draft",
    statusColor: "orange",
    lastModifiedBy: "Jane Smith",
    template: "DS_Template_01",
    dateTime: "6/01/2025 10:00 AM",
  },
  {
    id: "3",
    code: "VAPP_TEMP_COURSE003",
    name: "Frontend Mastery",
    status: "Draft",
    statusColor: "orange",
    lastModifiedBy: "Alice Brown",
    template: "FE_Template_07",
    dateTime: "6/10/2025 2:30 PM",
  },
  {
    id: "4",
    code: "VAPP_TEMP_COURSE004",
    name: "Backend Essentials",
    status: "Published",
    statusColor: "green",
    lastModifiedBy: "Bob Lee",
    template: "BE_Template_02",
    dateTime: "6/12/2025 9:15 AM",
  },
  {
    id: "5",
    code: "VAPP_TEMP_COURSE005",
    name: "Cloud Fundamentals",
    status: "Published",
    statusColor: "green",
    lastModifiedBy: "Carol King",
    template: "CL_Template_05",
    dateTime: "6/15/2025 11:45 AM",
  },
  {
    id: "6",
    code: "VAPP_TEMP_COURSE006",
    name: "AI for Everyone",
    status: "Draft",
    statusColor: "orange",
    lastModifiedBy: "David Kim",
    template: "AI_Template_09",
    dateTime: "6/18/2025 8:00 AM",
  },
];